var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "inputSearch",
      attrs: { "data-epica-module-name": _vm.epicaModule },
    },
    [
      _c("i", { staticClass: "quoteSearch icon-search" }),
      _vm._v(" "),
      _c(
        "multiselect",
        {
          attrs: {
            "deselect-label": "",
            "select-label": "",
            "track-by": "name",
            label: "name",
            options: _vm.acResult,
            multiple: false,
            placeholder: "Buscar indicador",
            "show-no-results": false,
          },
          on: { "search-change": _vm.searchQuote, select: _vm.selectOpt },
        },
        [
          _c("template", { slot: "noOptions" }, [
            _c("span", {
              domProps: {
                innerHTML: _vm._s("Consulte el indicador económico"),
              },
            }),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }